import { ResultFlag, ResultFlagName } from '@src/api';

export const resultOptions: { name: string; value: string }[] = [
  { name: ResultFlagName.CriticalHigh, value: ResultFlag.CriticalHigh },
  { name: ResultFlagName.CriticalLow, value: ResultFlag.CriticalLow },
  { name: ResultFlagName.Normal, value: ResultFlag.Normal },
  { name: ResultFlagName.Abnormal, value: ResultFlag.Abnormal },
  { name: ResultFlagName.AbnormalHigh, value: ResultFlag.AbnormalHigh },
  { name: ResultFlagName.AbnormalLow, value: ResultFlag.AbnormalLow },
];
